module.exports = __webpack_public_path__ + "img/33@2x.7c2d28dd.png";